import Http from 'common/services/Http';
import { Paged } from 'api/common/types/Page';
import { UnifiedContractListDto } from './models/UnifiedContractListDto';
import { UnifiedContractsSearchCriteria } from './models/UnifiedContractsSearchCriteria';
import { UnifiedContractsCountersDto } from './models/UnifiedContractsCountersDto';

class ContractsListingService {

    public getList(criteria: UnifiedContractsSearchCriteria) {
        return Http.get<Paged<UnifiedContractListDto>>('contractsListing', criteria);
    }

    public getCounters(criteria: UnifiedContractsSearchCriteria) {
        return Http.get<UnifiedContractsCountersDto>('contractsListing/counters', criteria);
    }
}

export default new ContractsListingService();
